"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewBoxSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: theme.spacing(2),
  padding: theme.spacing(2),
  margin: theme.spacing(3, 0),
  display: 'flex',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3)
  }
}));
const SkeletonIcon = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  marginRight: theme.spacing(1)
}));
const SkeletonArrow = (0, _mui.styled)(_mui.Skeleton)({
  marginLeft: 'auto'
});
const NewBoxSkeleton = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SkeletonIcon, {
    animation: "wave",
    variant: "circular",
    width: 24,
    height: 24
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
    animation: "wave",
    variant: "text",
    width: 130,
    height: 24
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SkeletonArrow, {
    animation: "wave",
    variant: "circular",
    width: 24,
    height: 24
  })]
});
exports.NewBoxSkeleton = NewBoxSkeleton;